<onsip-avatar-upload
  [hasDialog]="true"
  [useTempAvatar]="hasTempAvatar"
  [currentAvatar]="currentAvatar"
  (avatarChange)="dialogResponse($event)"
>
</onsip-avatar-upload>
